<template>
	<div :class="classes">
		<CharacteristicEdit
			v-model="items"
			ref="edit"
			:title="title"
			:with-keyword="withKeyword"
			:characteristic-items="characteristicItems"
			:characteristic-type="characteristicType"
			:nothing-allowed="{
				onlyOverall: true,
				overall: {
					text: nothingOverallText,
					inFan: true
				}
			}"
			:supplements-config="supplementsConfig || {
				disable: true
			}"
			:with-experience="withExperience"
			:with-education="withEducation"
			:experience-config="{
				noneAllowed: this.experienceNoneAllowed
			}"
			:selected-items-config="{
				lastLevelOnly: true,
				flat: true,
				styling: selectedItemsStyling,
				labelType: labelTypeApplication,
				sortType: 'experience'
			}"
			:header-info="headerInfo"
			:open-fan-label="openFanLabel"
			:with-edit-button="withEditButton"
			:group-by-letter="groupByLetter"
			:search-config="searchConfig"
			show-multiple-hint
			:completion-check-config="{
				enabled: completionCheckConfig.enabled !== undefined ? completionCheckConfig.enabled : true,
				label: completionCheckConfig.label,
				okButtonText: completionCheckConfig.okButtonText,
				popUpInfo: completionCheckApplicationExperienceInfo
			}"
			@finish="$emit('finish', $event)"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";
import Box from "@/vue/common/Box";
import {characteristicMultiple} from "@/helper/application/Populate";
import {isEmptyArray} from "@/helper/Array";
import {STYLING__LIST} from "@/vue/characteristic/SelectedItems"
import {APPLICATION} from "@/helper/characteristic/Label";
import {HEADER_INFO__APPLICATION_NO_EXPERIENCE} from "@/vue/characteristic/Fan.vue";
import {APPLICATION_EXPERIENCE} from "@/helper/characteristic/completion-check/Info";

export default {

	components: {
		Box,
		CharacteristicEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		initialData: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		nothingOverallText: {
			type: String,
			required: true,
		},
		characteristicItems: {
			type: Array,
			required: true,
		},
		characteristicType: {
			type: Object,
			required: true,
		},
		withKeyword: {
			type: Boolean,
			required: false,
			default: true,
		},
		withExperience: {
			type: Boolean,
			required: false,
			default: true,
		},
		withEducation: {
			type: Boolean,
			required: false,
			default: false,
		},
		experienceNoneAllowed: {
			type: Boolean,
			required: false,
			default: false,
		},
		openFanLabel: {
			type: String,
			required: false,
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: true,
		},
		groupByLetter: {
			type: Object,
			required: false
		},
		completionCheckConfig: {
			type: Object,
			required: false,
			default: () => ({})
		},
		searchConfig: {
			type: Object,
			required: false
		},
		supplementsConfig: {
			type: Object,
			required: false
		}
	},

	mounted ()
	{
		this.$emit('input', this.items);
	},

	data ()
	{
		let items = undefined;

		if (this.initialData)
		{
			items = characteristicMultiple(
				this.initialData,
				this.meta,
				this.characteristicItems,
				this.characteristicType,
				true
			);
		}

		return {
			items,
		};
	},

	computed: {
		classes ()
		{
			return {
				'inline': isEmptyArray(this.items)
			};
		},
		labelTypeApplication ()
		{
			return APPLICATION;
		},
		selectedItemsStyling ()
		{
			return STYLING__LIST;
		},
		headerInfo ()
		{
			return HEADER_INFO__APPLICATION_NO_EXPERIENCE;
		},
		completionCheckApplicationExperienceInfo ()
		{
			return APPLICATION_EXPERIENCE.replace('%label%', this.completionCheckConfig?.infoLabel);
		}
	},

	methods: {
		edit ()
		{
			this.$refs.edit.openFan();
		}
	}
}
</script>
